<template lang="">
	<div class="responsive-note">

    <v-alert
      v-if="success"
      dismissible
      text
      type="success"
    >
      Success
    </v-alert>

		<!-- Filter -->
    <CommunicationFilter/>
    
    <v-card>
      <v-data-table
        :headers="headers"
        :items="items.data"
        :range="7"
        class="elevation-2 fs-16 teste"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        hide-default-footer
        @page-count="pageCount = $event"
        loader-height
      >
        <template v-slot:item.communication_updated_at="{item}">
          {{format(item.communication_updated_at)}}
        </template>
        <template v-slot:item.communication_is_active="{item}">
          <status-toggle
            :item="item"
            :item-status="item.communication_is_active"
            item-type="communication_is_active"
            :updateAction="updateCommunication"
            :disableAction="disableCommunication"
          />
        </template>
        <template v-slot:item.actions="{item}">
          <button @click="setCommunication(item)" class="b-4 ma-2 editButtonCommunication">
            <img src="../../../../static/images/edit.svg"/>
          </button>
        </template>
        <template v-slot:no-data>
          <span>Registro não encontrado</span>
        </template>
			</v-data-table>
		</v-card>

    <!-- PAgination -->
    <v-card class="mt-8">
			<div
				v-if="!loading"
				class="list-footer">
				<span></span>
				<v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="7"
          color="#F0F1F3"
        ></v-pagination>
				<div class="goToPage">
					<span class="goToPage--text">
						Ir para página
					</span>
					<label>
						<input
							v-model="goToPage"
							type="text"
						>
						<button
							@click="goToPageRequest"
							:disabled="disabledGoTo"
						>
							<div
								class="button-wrapper--text">
								<i class="iconStyle icon-arrow-right d-flex justify-center align-center"></i>
							</div>
						</button>
						<span
							:class="showGoToPageHelpText ? '--show-helptext' : '--hide-helptext'"
							class="goToPage--helptext"
						>
							A página deve estar entre 1 e {{pageCount}}
						</span>
					</label>
				</div>
			</div>
		</v-card>

    <div style="height: 5px"></div>
    <!-- Editing Campaign -->
    <v-navigation-drawer
      v-model="drawer"
      fixed
      overlay
      temporary
      right
      width="620"
      height="100vh"
      style="background: var(--grey-day-010)"
    >
      <CommunicationForm v-on:close="drawer = false"/>
    </v-navigation-drawer>

	</div>
</template>
<script>
// Component
import StatusToggle from '@/components/StatusToggle.vue'
import CommunicationFilter from '@/components/Contents/AutomaticsTriggers/CommunicationFilter.vue'
import CommunicationForm from '@/components/Contents/AutomaticsTriggers/CommunicationForm.vue'

// Lib
import { mapActions, mapMutations, mapState } from 'vuex'
import VueCookies from 'vue-cookies'
// import VueCookies from 'vue-cookies'

//mixins
import date from '../../../mixins/date'
import toaster from '@/mixins/toaster.js'


export default {
  mixins: [date, toaster],
	components: {
		StatusToggle,
    CommunicationFilter,
    CommunicationForm
	},
  data () {
		return {
			goToPage: 1,
      showGoToPageHelpText: false,
      disabledGoTo: false,
      page: 1,
      itemsPerPage: 10,
      pageCount: 0,
      success: false,
      notification: false,
      drawer: false
		}
  },
	async created () {
    const token = VueCookies.get('jwt-login')
    this.setLoading(true)
    try {
      this.setStatusFilter(null)
      this.setProductFilter('')
      this.setProductPageSize(100)
      this.setCopyStatusFilter(null)
      this.setCopyProductFilter('')
      this.setCopyPageSize(100)
      this.getCopies({token: token})
      await this.getProducts({token: token})
      await this.getCommunications({token: token})
      this.setLoading(false)
    } catch (error) {
      console.error(error)
      this.toaster(
        'Erro na requisição',
        "warning",
        true
      );
    }
  },
  computed: {
    ...mapState('Product', {
      productItems: 'items',
    }),
    ...mapState('Communication', {
      items: 'items',
      loading: 'loading',
      size: 'size',
      pagination: 'pagination'
    }),
    productsList () {
      return this.productItems.data.map(product =>({
        value: product.product_id,
        label: product.product_name
      }))
    },
    headers () {
      return [
        // { value: '', text: '' ,class: 'header-table grey lighten-2 whiteSpace'},
        { value: 'copy.copy_name', text: 'Copy' ,class: 'header-table grey lighten-2'},
        { value: 'copy.product.product_name', text: 'Produto' ,class: 'header-table grey lighten-2'},
        { value: 'communication_id_shot', text: 'XPROMO ID' ,class: 'header-table grey lighten-2'},
        { value: 'communication_type', text: 'TIPO' ,class: 'header-table grey lighten-2'},
        { value: 'communication_updated_at', text: 'ATUALIZADO EM', sortable: true , class:"grey lighten-2"},
        { value: 'communication_is_active', text: 'STATUS' ,class: 'header-table grey lighten-2'},
        { value: 'actions', text: '', class:"grey lighten-2" }
      ]
    },
  },
  methods: {
    ...mapActions('Product', [
      'getProducts'
    ]),
    ...mapActions('Communication', [
      'getCommunications',
      'updateCommunication',
      'disableCommunication'
    ]),
		...mapActions('Copy', [
      'getCopies'
    ]),
    ...mapMutations('Product', {
      setProductPageSize: 'SET_PAGE_SIZE'
    }),
		...mapMutations('Copy', {
      setCopyStatusFilter: 'SET_STATUS_FILTER',
      setCopyProductFilter: 'SET_PRODUCT_FILTER',
      setCopyPageSize: 'SET_PAGE_SIZE'
    }),
    ...mapMutations('Communication', {
      setCommunicationToEdit: 'SET_COMMUNICATION_TO_EDIT',
      setLoading: 'SET_LOADING',
      setStatusFilter: 'SET_STATUS_FILTER',
      setProductFilter: 'SET_PRODUCT_FILTER',
    }),
		async goToPageRequest () {
      this.page = +this.goToPage
    },
		setCommunication (itemRow) {
      this.setCommunicationToEdit(itemRow)
      this.drawer = !this.drawer
    },
  },
	watch: {
    'goToPage' () {
      if (this.goToPage < 1 || this.goToPage > this.pageCount) {
        this.showGoToPageHelpText = true
        this.disabledGoTo = true
      } else {
        this.showGoToPageHelpText = false
        this.disabledGoTo = false
      }
    },
  }
}
</script>
<style lang="scss" scoped>
 .v-data-table-header {
  background: var(--grey-day-020);
  height: 64px;
  font-size: 18px !important;
}

.vs__search {
  margin-top:0px
}

th {
	font-size: 16px !important;
  height: 64px !important;
}

.header-table {
	font-size: 20px !important;
  height: 64px !important;
  background: var(--grey-day-020)!important;
}

.fs-16 {
	font-size: 16px !important;
}

.list-footer {
	background: var(--white);
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.75rem 2.625rem;
  margin: 80px 0 10px 0px;
	height: 64px;
}

.v-pagination__navigation, .v-pagination__item {
  border: none;
  box-shadow: none
}

.goToPage {
    &--text {
      font-size: 14px;
      font-family: var(--dm-sans-regular);
      color: var(--dark-grey);
      margin-right: 20px;
    }

    label {
      border: 2px solid var(--grey-day-030);
      background: var(--white);
      border-radius: 4px;
      box-sizing: border-box;
      max-width: 84px;
      width: 80px;
      padding: 10px;
      position: relative;

      input {
        width: 54px;
        font-size: 1rem;
        color: var(--grey);
        font-family: var(--dm-sans-regular);
      }

      button {
        position: absolute;
        border-radius: 50%;
        border: none;
        padding: 0;
        top: 11px;
        right: 8px;
        background: var(--grey);
        cursor: pointer;

        i {
          color: var(--white);
          font-size: 1.25rem;
        }
      }

      button:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }

    &--helptext {
      font-family: var(--dm-sans-regular);
      position: absolute;
      font-size: 12px;
      width: 120px;
      text-align: center;
      top: -55px;
      left: -24px;
      background: var(--dark-red);
      padding: 8px;
      color: var(--light-grey);
      border-radius: 4px;
    }

    .--hide-helptext {
      display: none;
    }

    .--show-helptext {
      display: block;
    }
  }

	.iconStyle {
		width: 20px;
		height: 20px;
		background: transparent
	}

	.responsive-note {
    width: 1224px
  }
  @media screen and (max-width: 1377px) {
    .whiteSpace{
      display: none;
    }

    .responsive-note {
      width: 819px
    }
  }

  // Edit button
  .editButtonCommunication {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/Contents/AutomaticsTriggers/Communication.vue